"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipPositionPlacement = void 0;
var TooltipPositionPlacement;
(function (TooltipPositionPlacement) {
    TooltipPositionPlacement["TOP"] = "top";
    TooltipPositionPlacement["BOTTOM"] = "bottom";
})(TooltipPositionPlacement || (TooltipPositionPlacement = {}));
exports.TooltipPositionPlacement = TooltipPositionPlacement;
//# sourceMappingURL=types.js.map